import { gql } from "@apollo/client";
const FlowsFragment = gql`
  fragment FlowsFragment on Flow {
    id
    changelist {
      id
      description
    }
    launched_by {
      name
      email
    }
    created
    failed
    phase
    report_datetime {
      short
      long
      long_utc
      iso
    }
    status
    inputs {
      name
      source_table {
        id
        name
        project
        bundle {
          report_handle
          recent_failed_probe
          recent_successful_probe
          next_probe
        }
      }
      download {
        id
        report_datetime {
          short
          long
          long_utc
          iso
        }
        created
        started
        finished
        status
        handle
        progress
      }
      download_part {
        id
        row_count
        dirty_row_count
        dirty_row_status
        legacy_flow_source_id
        download {
          id
          handle
          status
          finished
        }
      }
    }
    processing {
      id
      started
      finished
      status
    }
    outputs {
      id
      name
      project
      handle
      row_count
      created
      started
      finished
      status
      report_datetime {
        short
        long
        long_utc
        iso
      }
      declaration {
        id
      }
    }
    events {
      id
      created
      message
      severity
      project_name
      download {
        id
      }
      flow {
        id
      }
      upload {
        id
      }
      will_retry
      comment
      commented_on
      commented_by {
        name
      }
    }
  }
`;
export { FlowsFragment };
